let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2uxyc")).then(() => parcelRequire('2BNCB'));